export const enums = {
  INITIATED: "initiated",
  PARTIALLY_ALLOCATED: "partially_allocated",
  COMPLETED: "completed",
  REJECTED: "rejected",
};

export const mapping = {
  [enums.INITIATED]: "Инициирован",
  [enums.PARTIALLY_ALLOCATED]: "Частично распределён",
  [enums.COMPLETED]: "Распределён",
  [enums.REJECTED]: "Отклонён",
};

export const mappingStyles = {
  [enums.INITIATED]: {
    title: "Инициирован",
    color: "yellow",
    icon: "undo-2",
  },
  [enums.PARTIALLY_ALLOCATED]: {
    title: "Частично распределён",
    color: "blue-light",
    icon: "split",
  },
  [enums.COMPLETED]: {
    title: "Распределён",
    color: "green-light",
    icon: "copy-check",
  },
  [enums.REJECTED]: {
    title: "Отклонён",
    color: "red-light",
    icon: "copy-x",
  },
};

// Статусы, при которых возврат считается открытым (требует решения диспетчера)
export const openStatuses = [enums.INITIATED, enums.PARTIALLY_ALLOCATED];

// Значение фильтра «Открытые» для GET /applications/returns?status= (initiated + partially_allocated)
export const OPEN_STATUS_FILTER = "open";

export const allocationTypes = {
  TO_BASE: "to_base",
  TO_APPLICATION: "to_application",
};

export const allocationTypeMapping = {
  [allocationTypes.TO_BASE]: "На базу",
  [allocationTypes.TO_APPLICATION]: "На заявку",
};

export const isOpenReturnStatus = (status) => openStatuses.includes(status);
